import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LinkRendererComponent } from './link-renderer/link-renderer.component';
import { CrudOperationsRendererComponent } from './crud-operations-renderer/crud-operations-renderer.component';

import { ButtonModule } from '@shared/components/button/button.module';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    RouterModule
  ],
  declarations: [
    LinkRendererComponent,
    CrudOperationsRendererComponent
  ],
  exports: [
    LinkRendererComponent,
    CrudOperationsRendererComponent
  ]
})
export class CellRenderersModule { }
